import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import { isApplePayEnabled } from '@/utils/environment'

import ContainerLeft from '@/views/Checkout/partials/ContainerLeft/ContainerLeft.vue'
import ContainerLeftNew from '@/views/Checkout/partials/ContainerLeft/ContainerLeftNew.vue'

import StepData from '@/views/Checkout/partials/steps/StepData/StepData.vue'
import Delivery from '@/views/Checkout/partials/steps/Delivery/Delivery.vue'
import ReviewContactAddress from '@/views/Checkout/partials/steps/Delivery/review/ReviewContactAddress/ReviewContactAddress.vue'

import Payment from '@/views/Checkout/partials/steps/Payment/Payment.vue'
import PaymentCard from '@/views/Checkout/partials/steps/Payment/payments/PaymentCard/PaymentCard.vue'
import PaymentApplePay from '@/views/Checkout/partials/steps/Payment/payments/PaymentApplePay/PaymentApplePay.vue'
import PaymentBillet from '@/views/Checkout/partials/steps/Payment/payments/PaymentBillet/PaymentBillet.vue'
import PaymentBilletSuccess from '@/views/Checkout/partials/steps/Payment/payments/PaymentBillet/PaymentBilletSuccess/PaymentBilletSuccess.vue'
import PaymentPix from '@/views/Checkout/partials/steps/Payment/payments/PaymentPix/PaymentPix.vue'
import PaymentPixSuccess from '@/views/Checkout/partials/steps/Payment/payments/PaymentPix/PaymentPixSuccess/PaymentPixSuccess.vue'
import PaymentCardOffer from '@/views/Checkout/partials/steps/Payment/payments/PaymentCard/PaymentCardOffer/PaymentCardOffer.vue'
import PaymentSuccess from '@/views/Checkout/partials/steps/Payment/PaymentSuccess/PaymentSuccess.vue'
import PaymentError from '@/views/Checkout/partials/steps/Payment/PaymentError/PaymentError.vue'
import PaymentCardLoading from '@/views/Checkout/partials/steps/Payment/payments/PaymentCard/PaymentCardLoading/PaymentCardLoading.vue'
import PaymentPixConfirmed from '@/views/Checkout/partials/steps/Payment/payments/PaymentPix/PaymentPixSuccess/PaymentPixConfirmed/PaymentPixConfirmed.vue'

Vue.use(VueRouter)

function hasQueryParams(route) {
  return !!Object.keys(route.query).length
}

let query = {}

const routes = [
  {
    path: '/',
    component: ContainerLeftNew,
    beforeEnter: (to, from, next) => {
      if (hasQueryParams(to)) {
        query = { ...query, ...to.query }
        store.commit('SET_PL', { ...query, ...to.query })
      }
      if (to.query?.cart || to.path === '/') {
        store.commit('Checkout/SET_CART_HASH', { cart: to.query?.cart })
        next({ name: 'new.dataStep', query: { pl: query?.pl } })
      } else {
        next({ query: { pl: query?.pl } })
      }
    },
    children: [
      {
        name: 'new.dataStep',
        path: 'dados',
        component: StepData,
      },
      {
        name: 'new.stepAddress',
        path: 'endereco',
        component: Delivery,
      },
      {
        name: 'new.stepReviewAddress',
        path: 'frete',
        component: ReviewContactAddress,
      },
      {
        name: 'new.stepPayment-applepay',
        path: '/pagamento-applepay',
        component: PaymentApplePay,
        beforeEnter: (_to, _from, next) => {
          if (isApplePayEnabled()) {
            next()
          } else {
            window.history.back()
          }
        },
      },
      {
        name: 'new.stepPayment',
        path: 'pagamento',
        component: Payment,
      },
      {
        name: 'new.stepPayment-card',
        path: '/pagamento-cartao',
        component: PaymentCard,
      },
      {
        name: 'new.stepPayment-billet',
        path: '/pagamento-boleto',
        component: PaymentBillet,
      },
      {
        name: 'new.stepPaymentBilletSuccess',
        path: '/pagamento-boleto-sucesso',
        component: PaymentBilletSuccess,
      },
      {
        name: 'new.stepPayment-pix',
        path: '/pagamento-pix',
        component: PaymentPix,
      },
      {
        name: 'new.stepPaymentPixSuccess',
        path: '/pagamento-pix-sucesso',
        component: PaymentPixSuccess,
      },
      {
        name: 'new.stepPaymentPixConfirmed',
        path: '/pagamento-pix-confirmado',
        component: PaymentPixConfirmed,
      },
      {
        name: 'new.stepPaymentCardOffer',
        path: '/oferta',
        component: PaymentCardOffer,
        beforeEnter: (to, from, next) => {
          const orderBumps = !!store.getters['Cart/getOrderBumps']
          if (orderBumps) {
            store.commit('Cart/SET_ORDER_REDIRECT', true)
            next({ query: { pl: query?.pl } })
          } else {
            next({ name: 'new.stepPayment', query: { pl: query?.pl } })
          }
        },
      },
      {
        name: 'new.stepPaymentSuccess',
        path: '/pagamento-cartao-sucesso',
        component: PaymentSuccess,
      },
      {
        name: 'new.stepPaymentApplePaySuccess',
        path: '/pagamento-applepay-sucesso',
        component: PaymentSuccess,
      },
      {
        name: 'new.stepPaymentCardLoading',
        path: '/pagamento-cartao-carregando',
        component: PaymentCardLoading,
      },
      {
        name: 'new.stepPaymentError',
        path: '/pagamento-erro',
        component: PaymentError,
      },
    ],
  },
  {
    path: '*',
    redirect: {
      name: 'new.dataStep',
    },
  },
  {
    path: '/old',
    component: ContainerLeft,
    children: [
      {
        name: 'checkout.stepData',
        path: '/dados',
        component: StepData,
      },
      {
        name: 'checkout.stepAddress',
        path: '/endereco',
        component: Delivery,
      },
      {
        name: 'checkout.stepReviewAddress',
        path: '/frete',
        component: ReviewContactAddress,
      },
      {
        name: 'checkout.stepPayment',
        path: '/pagamento',
        component: Payment,
      },
      {
        name: 'checkout.stepPaymentCard',
        path: '/pagamento-cartao',
        component: PaymentCard,
      },
      {
        name: 'checkout.stepPaymentBillet',
        path: '/pagamento-boleto',
        component: PaymentBillet,
      },
      {
        name: 'checkout.stepPaymentBilletSuccess',
        path: '/pagamento-boleto-sucesso',
        component: PaymentBilletSuccess,
      },
      {
        name: 'checkout.stepPaymentPix',
        path: '/pagamento-pix',
        component: PaymentPix,
      },
      {
        name: 'checkout.stepPaymentPixSuccess',
        path: '/pagamento-pix-sucesso',
        component: PaymentPixSuccess,
      },
      {
        name: 'checkout.stepPaymentCardOffer',
        path: '/oferta',
        component: PaymentCardOffer,
      },
      {
        name: 'checkout.stepPaymentSuccess',
        path: '/pagamento-pagamento-sucesso',
        component: PaymentSuccess,
      },
      {
        name: 'checkout.stepPaymentCardLoading',
        path: '/pagamento-pagamento-carregando',
        component: PaymentCardLoading,
      },
      {
        name: 'checkout.stepPaymentError',
        path: '/pagamento-pagamento-erro',
        component: PaymentError,
      },
      {
        path: '/shopify',
        name: 'Shopify',
      },
      {
        path: '/shopify-iframe',
        name: 'Shopify-iframe',
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: `${process.env.BASE_URL}/checkout/`,
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.name === 'Shopify' || to.name === 'Shopify-iframe') {
    next({ query: { pl: query?.pl } })
  }
  if (!to.name) {
    next({ name: 'new.dataStep', query: to.query })
  }
  next({ query: { pl: query?.pl } })
})

export default router
